import "./index.less";

const LodingButton = (props) => {
    const {onClick, text } = props;
    return (
        <div className='loding'>
            <R.Button
                classify="info"
                className="reverse"
                text={text}
                attrs={{ 'style': 'border-radius: 8px; font-size: 18px ;height: 42px; color: #5D6778; background: #E6E7E8;position: absolute; top: -3px; right: 12px;' }}
                icon={'fia-spinner-loading'}
                onClick={onClick}
            />
        </div>
    );
};
export default LodingButton;